/* @flow */

import React, { Component } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from './actions';
import DiffusionCard from './components/DiffusionCard';

type Props = {
  loadInitialDatas: () => void,
};

class Edit extends Component {
  props: Props;

  componentDidMount() {
    this.props.loadInitialDatas();
  }

  render() {
    return (
      <Router>
        <DiffusionCard />
      </Router>
    );
  }
}

export default connect(undefined, {
  loadInitialDatas: Actions.loadInitialDatas,
})(Edit);



// WEBPACK FOOTER //
// ./src/modules/campaign/Edit.js